import type { ITranslationLanguage } from '../challenges/enums/translation-language';
import { LANGUAGE_CODE_BY_SLUG } from './language-slug-map';

export function getLanguageCodeBySlug(slug: string): ITranslationLanguage | undefined {
  return LANGUAGE_CODE_BY_SLUG[slug];
}
